/*
* Redux actions
*/

export function fetchAll() {
  return dispatch => {
    return fetch("api/grouping")
      .then(response => response.json())
      .then(groupingJson => {
        groupingJson.forEach(gObj => {
          gObj.groupings.sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            } else if (a.name < b.name) {
              return -1;
            }
            return 0;
          });
        });
        const selectedIdxs = [1, 2, 3, 4, 5]; // NB: all families and cemetery (seems to be done by color class)
        dispatch(updateGroupings(groupingJson, selectedIdxs));

        return fetch("api/evidence");
      })
      .then(response => response.json())
      .then(json => {
        const domain = {
          images: json.filter(evidence => evidence.format === "image"),
          audios: json.filter(evidence => evidence.format === "audio"),
          videos: json.filter(evidence => evidence.format === "video"),
          shapes: json.filter(evidence => evidence.format === "shape")
        };
        dispatch(updateDomain(domain));
      });
  };
}

export function fetchDomain() {
  return dispatch => {
    //dispatch(toggleFetchingDomain());
    const domain = {};
    return fetch("api/evidence")
      .then(response => response.json())
      .then(json => {
        domain.images = json.filter(evidence => evidence.format === "image");
        domain.audios = json.filter(evidence => evidence.format === "audio");
        domain.videos = json.filter(evidence => evidence.format === "video");
        domain.shapes = json.filter(evidence => evidence.format === "shape");
        return domain;
      });
  };
}

export function fetchGroupings() {
  return dispatch => {
    //dispatch(toggleFetchingDomain());
    return fetch("api/grouping")
      .then(response => response.json())
      .then(json => {
        return json;
      });
  };
}

export function fetchSearchResults(searchQuery) {
  return dispatch => {
    return fetch(`api/evidence/search/${searchQuery}`)
      .then(response => response.json())
      .then(json => {
        return json;
      });
  };
}

export function fetchSprite(sprite, languageId) {
  // console.log("fetching sprite...", sprite.id);
  return dispatch => {
    // dispatch(toggleFetchingSprite());
    return fetch(`api/evidence/${sprite.id}`)
      .then(response => response.json())
      .then(json => {
        //dispatch(toggleFetchingsSprite());
        return json;
      })
      .catch(error => {
        console.log("Something happened fetching a sprite...");
      });
  };
}

/*
 * action creators
 */
export const SELECT_SPRITE = "SELECT_SPRITE";
export function selectSprite(selectedSpriteId) {
  return { type: SELECT_SPRITE, selectedSpriteId };
}
export const SELECT_YEAR = "SELECT_YEAR";
export function selectYear(selectedYearIdx) {
  return { type: SELECT_YEAR, selectedYearIdx };
}
export const SELECT_GROUPING = "SELECT_GROUPING";
export function selectGrouping(groupingId) {
  return { type: SELECT_GROUPING, groupingId };
}
export const SELECT_LANGUAGE = "SELECT_LANGUAGE";
export function selectLanguage(languageId) {
  return { type: SELECT_LANGUAGE, languageId };
}

export const UPDATE_DOMAIN = "UPDATE_DOMAIN";
export function updateDomain(domain) {
  return {
    type: UPDATE_DOMAIN,
    domain: domain
  };
}
export const UPDATE_GROUPINGS = "UPDATE_GROUPINGS";
export function updateGroupings(groupings, selected) {
  return {
    type: UPDATE_GROUPINGS,
    groupings,
    selected
  };
}
export const UPDATE_SPRITE_DATA = "UPDATE_SPRITE_DATA";
export function updateSpriteData(spriteData) {
  return {
    type: UPDATE_SPRITE_DATA,
    selectedSpriteData: spriteData
  };
}
export const UPDATE_SEARCH_RESULTS = "UPDATE_SEARCH_RESULTS";
export function updateSearchResults(searchResults) {
  return { type: UPDATE_SEARCH_RESULTS, searchResults };
}

export const TOGGLE_POINTCLOUD = "TOGGLE_POINTCLOUD";
export function togglePointcloud(isShowingPointcloud) {
  return { type: TOGGLE_POINTCLOUD, isShowingPointcloud };
}

export const SET_LOADING = "SET_LOADING";
export function setLoading(loadingFlag, isLoading) {
  return { type: SET_LOADING, loadingFlag, isLoading };
}

export const SET_LOADING_PROGRESS = "SET_LOADING_PROGRESS";
export function setLoadingProgress(progress) {
  return { type: SET_LOADING_PROGRESS, progress };
}



// WEBPACK FOOTER //
// ./application/frontend/src/actions/index.js